import Harvest from './index'
import HarvestData from './components/harvestData/harvestData.vue'
export default [
  {
    path: '/harvest',
    component: Harvest
  },
  {
    path: '/harvest/entry',
    name: '/harvest/entry',
    component: HarvestData,
    props: (route) => ({
      reportId: route.query.id,
      mode: route.params.mode
    })
  }
]
